export default __webpack_public_path__ + "static/media/AmitPandey.6c6f8e41.jpeg";